export const filenameFromContentDisposition = (headers: Headers, fallback: string): string => {
  const raw = headers.get('Content-Disposition')?.split('filename=')[1];
  return raw ? raw.replace(/^"|"$/g, '') : fallback;
};

export const downloadDocument = (documentData: Blob, fileName: string) => {
  const blobURL = window.URL.createObjectURL(documentData);
  const tempLink = document.createElement('a');
  tempLink.style.display = 'none';
  tempLink.href = blobURL;
  tempLink.setAttribute('download', fileName);

  // Safari thinks _blank anchor are pop ups. We only want to set _blank
  // target if the browser does not support the HTML5 download attribute.
  // This allows you to download files in desktop safari if pop up blocking
  // is enabled.
  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank');
  }

  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
  window.URL.revokeObjectURL(blobURL);
};
